import React from 'react';
import { connect } from 'react-redux';

import { hideEmail } from './form-otp-login';

import Btn from '../global/button';
import Pictogram from '../global/pictogram';

import TranslatedCopy from '../../intl/translated-copy';

const mapStateToProps = state => {
  return ({
    metrixEmailCopy: state.UserProfileSession.metrixEmailCopy,
    profileOtpSettings: state.Manage.profileOtpSettings,
  });
};

const FormOtpLoginError = (props) => {
  const {
    handleButtonClick,
    metrixEmailCopy,
    profileOtpSettings: {
      recoverOtpSettingsSent = null,
    },
  } = props;

  const {
    maskedEmail: maskedRecoveryPassword = null,
  } = recoverOtpSettingsSent || {};

  const emailFromRecoveryPassword = Boolean(maskedRecoveryPassword);
  const maskedEmail = !emailFromRecoveryPassword ? hideEmail(metrixEmailCopy) : hideEmail(maskedRecoveryPassword);

  return (
    <div className='form-otpLoginError-container'>
      { !emailFromRecoveryPassword &&
        <div className='form-otpLoginError-header'>
          <span className='Icon Icon--warningBrandblue' />
          <TranslatedCopy
            className='otpLoginError-header-content'
            copyID='PRO_HOME_LOGIN_OTP_ERROR_2' />
        </div>
      }
      <div className='form-otpLoginError-main'>
        <div className='otpLoginError-body'>
          <div className='otpLoginError-imageBody'>
            <i className='Icon Icon--Password' />
            <Pictogram
              className='CircleOff'
              id='CircleOffNew' />
          </div>
          <TranslatedCopy
            className='otpLoginError-body-header'
            copyID='PRO_HOME_LOGIN_OTP_ERROR_TITLE' />
          <p className='otpLoginError-body-content'>
            <TranslatedCopy
              copyID='PRO_HOME_LOGIN_OTP_ERROR_DESCRIPTION'
              email_id={ maskedEmail } />
          </p>
          <TranslatedCopy
            className='otpLoginError-body-subtitle'
            copyID='PRO_HOME_LOGIN_OTP_ERROR_TIME' />
          <Btn
            block={ true }
            btnType='submit'
            className='otpLoginError-btn'
            copyID='PRO_HOME_LOGIN_OTP_ERROR_BUTTON'
            filled={ true }
            onBtnClick={ handleButtonClick } />
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(FormOtpLoginError);
